"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../components");
var _formElements = require("@evidation/form-elements");
var _useTranslated = require("../../hooks/useTranslated");
var _ui = require("@evidation/ui");
var _utils = require("@evidation/form-elements/lib/utils");
var _validations = _interopRequireDefault(require("./validations"));
var _excluded = ["input", "config", "extra_values", "unit_type", "hint_text"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WeightInternational = function WeightInternational(_ref) {
  var _ref$input = _ref.input,
    onChange = _ref$input.onChange,
    name = _ref$input.name,
    value = _ref$input.value,
    config = _ref.config,
    extra_values = _ref.extra_values,
    _ref$unit_type = _ref.unit_type,
    unit_type = _ref$unit_type === void 0 ? 'all' : _ref$unit_type,
    hint_text = _ref.hint_text,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var unitTypeMap = {
    pounds: 'pound',
    stones_as_pounds: 'stone',
    kilograms: 'metric'
  };
  var units = function units(formName, inputName) {
    if (!extra_values || !formName || !inputName) {
      return '';
    }
    var triageUnitsAttr = "".concat(inputName.slice(formName.length + 1), "_units");
    return unitTypeMap[extra_values[triageUnitsAttr]];
  };
  var initialUnitType = units(config.form, name);
  var _useState = (0, _react.useState)({
      pounds: undefined,
      stones: undefined
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imperialWeightValue = _useState2[0],
    setImperialWeightValue = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    weight = _useState4[0],
    setWeight = _useState4[1];
  var _useState5 = (0, _react.useState)(initialUnitType),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    unitChoice = _useState6[0],
    setUnitChoice = _useState6[1];

  // Trigger redux forms onChange event that is passed into the form,
  // this allows customized payload even with multiple field types.
  var handleChange = (0, _react.useCallback)(function (value, units) {
    var measurement = (0, _typeof2["default"])(value) === 'object' ? value : String(value).length === 0 ? '' : isNaN(value) ? '' : value;
    onChange((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, measurement), "".concat(name, "_units"), units));
  }, [name, onChange]);
  var canUse = (0, _react.useCallback)(function (type) {
    return unit_type.toLowerCase() === 'all' && unitChoice === type || unit_type.toLowerCase() === type;
  }, [unitChoice, unit_type]);
  var handleChangeStones = (0, _react.useCallback)(function (value) {
    var parseValue = value !== null && value !== undefined && String(value).length > 0 ? value : '';
    setImperialWeightValue(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        stones: parseValue
      });
    });
    //before change weight we need get the rest of pounds to sum in the total weight
    var restOfPounds = weight ? weight % 14 : 0;
    // we sum the rest of pounds to the value in stones converted to pounds
    var valueToPounds = restOfPounds + Number(parseValue) * 14;
    setWeight(valueToPounds);
    handleChange({
      pounds: imperialWeightValue.pounds !== undefined ? imperialWeightValue.pounds : '',
      stones: parseValue
    }, 'stones_as_pounds');
  }, [handleChange, imperialWeightValue, weight]);
  var handleChangePounds = (0, _react.useCallback)(function (value) {
    var parseValue = value !== null && value !== undefined && String(value).length > 0 ? value : '';
    var currentStones = 0;
    if (canUse('stone') && weight) {
      // here we convert values to integer in stones and after this to pounds
      currentStones = imperialWeightValue.stones * 14;
    }
    var valueToPounds = currentStones + Number(parseValue);
    setWeight(valueToPounds);
    setImperialWeightValue(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        pounds: parseValue
      });
    });
    if (canUse('stone')) {
      handleChange({
        stones: imperialWeightValue.stones !== undefined ? imperialWeightValue.stones : '',
        pounds: parseValue
      }, 'stones_as_pounds');
    } else {
      handleChange(parseValue, 'pounds');
    }
  }, [canUse, handleChange, imperialWeightValue, weight]);
  (0, _react.useEffect)(function () {
    if (!initialUnitType || !value) {
      return;
    }
    if (initialUnitType === 'pound') {
      handleChangePounds(value);
    } else if (initialUnitType === 'stone') {
      var stones = null;
      var pounds = null;
      if ((0, _typeof2["default"])(value) === 'object') {
        stones = value[name].stones;
        pounds = value[name].pounds;
      } else {
        stones = Math.floor(value / 14);
        pounds = value % 14;
      }
      handleChangeStones(stones);
      handleChangePounds(pounds);
      handleChange({
        pounds: pounds,
        stones: stones
      }, 'stones_as_pounds');
    } else if (initialUnitType === 'metric') {
      handleChange(value, 'kilograms');
    }
  }, [initialUnitType]);
  var imperialWeight = (0, _useTranslated.useTranslated)('fields.weightInternational.imperialWeight');
  var stoneWeight = (0, _useTranslated.useTranslated)('fields.weightInternational.stoneWeight');
  var metricWeight = (0, _useTranslated.useTranslated)('fields.weightInternational.metricWeight');
  var poundsText = (0, _useTranslated.useTranslated)('fields.weightInternational.pounds');
  var stonesText = (0, _useTranslated.useTranslated)('fields.weightInternational.stones');
  var kilogramsText = (0, _useTranslated.useTranslated)('fields.weightInternational.kilograms');
  var selectPlaceholderText = (0, _useTranslated.useTranslated)('components.select.placeholder');

  // Using label feature because it will keep the value the same,
  // but allow us to use translations in the future.
  var unitOptions = [{
    label: poundsText,
    value: 'pound'
  }, {
    label: stonesText,
    value: 'stone'
  }, {
    label: kilogramsText,
    value: 'metric'
  }];
  var clearValues = function clearValues(value) {
    switch (value) {
      case 'stones_as_pounds':
        onChange((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, {
          pounds: '',
          stones: ''
        }), "".concat(name, "_units"), value));
        break;
      case 'pounds':
        onChange((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, {
          pounds: '',
          stones: ''
        }), "".concat(name, "_units"), value));
        break;
      default:
        onChange((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, ''), "".concat(name, "_units"), value));
        break;
    }
    setWeight(undefined);
    setImperialWeightValue({
      pounds: undefined,
      stones: undefined
    });
  };
  var isBoth = function isBoth() {
    return unit_type.toLowerCase() === 'all';
  };
  var hasError = props.meta.error && props.meta.touched;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "evi--weight-intl"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleFieldset, {
    error: hasError
  }, /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
    schemaHasHeading: props.schemaHasHeading,
    numberOfInputs: props.numberOfInputs
  }, (0, _utils.stripHtml)(props.label || '')), hint_text ? /*#__PURE__*/_react["default"].createElement(_formElements.HintText, {
    text: hint_text,
    id: "".concat(name, "_hint")
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    role: "alert",
    id: "t-".concat(name, "_error-message_")
  }, hasError && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, props.meta.error)), isBoth() && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "sr-only",
    htmlFor: "t-".concat(name, "_select_unit_type")
  }, "Enter Weight Unit"), /*#__PURE__*/_react["default"].createElement(_components.SelectInput, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, props), {}, {
    hint_text: undefined,
    config: _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, config), {}, {
      name: 'select_unit_type',
      id: "t-".concat(name, "_select_unit_type")
    })), {}, {
      hint_text: undefined,
      id: "t-".concat(name, "_select_unit_type")
    })
  }), {
    "data-test-id": "selectUnitType",
    meta: _objectSpread(_objectSpread({}, props.meta), {}, {
      error: !unitChoice && props.meta.error
    }),
    options: unitOptions,
    label: "",
    name: "select_unit_type",
    convertValuesToStrings: false,
    "aria-describedby": "t-".concat(name, "_error-message_ ").concat(name, "_hint"),
    onChange: function onChange(value) {
      clearValues(value);
      setUnitChoice(value);
    },
    value: unitChoice,
    initialValue: selectPlaceholderText
  }))), /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
    items: "center",
    fullWidth: true,
    spaceX: 4
  }, canUse('stone') && /*#__PURE__*/_react["default"].createElement(_components.NumberInput, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, props), {}, {
    hint_text: undefined,
    config: _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, config), {}, {
      id: "t-".concat(name)
    })), {}, {
      hint_text: undefined,
      numberOfInputs: 2,
      schemaHasHeading: true
    }),
    name: name,
    id: "t-".concat(name)
  }), {
    showErrorBorder: false,
    "data-test-id": "stoneWeight",
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      var regex = /^[0-9.]*$/;
      if (value !== '' && (!regex.test(value) || isNaN(value))) return;
      handleChangeStones(value);
    },
    "aria-describedby": "t-".concat(name, "_error-message_ ").concat(name, "_hint"),
    label: stoneWeight,
    value: imperialWeightValue.stones,
    unit: stonesText,
    standAlone: false,
    srOnly: true
  })), (canUse('pound') || canUse('stone')) && /*#__PURE__*/_react["default"].createElement(_components.NumberInput, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, props), {}, {
    hint_text: undefined,
    config: _objectSpread(_objectSpread({}, config), {}, {
      hint_text: undefined,
      numberOfInputs: 2,
      schemaHasHeading: true,
      id: "t-".concat(name)
    }),
    name: name,
    id: "t-".concat(name)
  }), {
    showErrorBorder: false,
    "data-test-id": "imperialWeight",
    onChange: function onChange(_ref3) {
      var value = _ref3.target.value;
      var regex = /^[0-9.]*$/;
      if (value !== '' && (!regex.test(value) || isNaN(value))) return;
      handleChangePounds(value);
    },
    "aria-describedby": "t-".concat(name, "_error-message_ ").concat(name, "_hint"),
    label: imperialWeight,
    value: imperialWeightValue.pounds,
    unit: poundsText,
    standAlone: false,
    srOnly: true
  })), canUse('metric') && /*#__PURE__*/_react["default"].createElement(_components.NumberInput, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, props), {}, {
    inputMode: 'decimal',
    config: _objectSpread(_objectSpread({}, config), {}, {
      hint_text: undefined,
      numberOfInputs: 2,
      schemaHasHeading: true,
      name: name,
      id: "t-".concat(name)
    }),
    id: "t-".concat(name)
  }), {
    name: "".concat(name, "_metric"),
    showErrorBorder: false,
    "data-test-id": "metricWeight",
    onChange: function onChange(_ref4) {
      var value = _ref4.target.value;
      var regex = /^[0-9.]*$/;
      if (!regex.test(value)) return;
      setWeight(value);
      handleChange(value, 'kilograms');
    },
    label: metricWeight,
    srOnly: true,
    value: weight,
    unit: kilogramsText,
    standAlone: false
  })))));
};
WeightInternational.handlesErrorDisplay = true;
WeightInternational.showWarningIconOnError = false;
var _default = exports["default"] = WeightInternational;